import { TableCell, type TableCellProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import type React from "react";

const PREFIX = "TableCellLinkContainer";
export const classes = {
  cell: `${PREFIX}-cell`,
  link: `${PREFIX}-link`,
};

interface ITableCellLinkContainerProps extends Omit<TableCellProps, "padding"> {
  cellPadding?: number | string;
}

export const TableCellLinkContainer = styled<React.FC<ITableCellLinkContainerProps>>(TableCell, {
  shouldForwardProp: (propName) => propName !== "cellPadding",
})(({ theme, cellPadding }) => ({
  [`&.${classes.cell}`]: {
    padding: "0px",
    height: "100%",
    [`& .${classes.link}`]: {
      alignItems: "center",
      display: "flex",
      height: `calc(100% - ${
        typeof cellPadding === "string" ? `${cellPadding} - ${cellPadding}` : theme.spacing((cellPadding ?? 1) * 2)
      })`,
      padding: typeof cellPadding === "string" ? cellPadding : theme.spacing(cellPadding ?? 1),
      color: "inherit",
      textDecoration: "none",
      "&:focus, &:hover, &:visited, &:link, &:active": {
        textDecoration: "none",
        color: "inherit",
      },
    },
  },
}));
